import React from 'react';
import { connect } from '@gasbuddy/react';
import SignupForm from './signup-form';
import sharedStyle from '../../styles/shared.css';
import LoggedOutLayout from '../../components/logged-out-layout';
import FormMessage from '../../components/form-message';

/* eslint-disable react/prefer-stateless-function */
class Signup extends React.Component {
  render() {
    return (
      <LoggedOutLayout>
        <div className={sharedStyle.textCenter}>
          <FormMessage
            title="Signup"
            subTitle="<fill in></fill>"
          />
        </div>
        <SignupForm />
      </LoggedOutLayout>
    );
  }
}

export default connect()(Signup);
